import React, { useEffect, useState } from "react"
import Header from "./Header"
import Map, { CollarStyle, MapProjection, Basemap } from "./Map"
import { LocalOverlay } from "./localOverlays"
import "./App.css"
import { t } from "i18next"

function App() {
  const [windowHeight, setWindowHeight] = useState<number>(window.innerHeight) // Use to get correct height of mobile screen because of the navigation/address bar
  const [overlays, setOverlays] = useState<LocalOverlay[]>([]) // local KML/KMZ overlays, never sent to server
  const [collarStyle, setCollarStyle] = useState<CollarStyle>("icon") // "icon" SVG markers vs "circle" colored dots
  const [projection, setProjection] = useState<MapProjection>("globe") // globe vs flat (mercator)
  const [basemap, setBasemap] = useState<Basemap>("satellite") // satellite / streets / outdoors / 3D terrain
  const [collarOpacity, setCollarOpacity] = useState<number>(1) // render opacity of animal markers

  useEffect(() => {
    window.addEventListener("resize", () => {
      setWindowHeight(window.innerHeight)
    })
  }, [])

  return (
    <div className="App">
      <title>{t("title")}</title>
      <div className="AppHeaderContainer" style={{ height: `${windowHeight * 0.1}px` }}>
        <Header
          overlays={overlays}
          setOverlays={setOverlays}
          collarStyle={collarStyle}
          setCollarStyle={setCollarStyle}
          projection={projection}
          setProjection={setProjection}
          basemap={basemap}
          setBasemap={setBasemap}
          collarOpacity={collarOpacity}
          setCollarOpacity={setCollarOpacity}
        />
      </div>
      <div className="AppMapContainer" style={{ height: `${windowHeight * 0.9}px` }}>
        <Map
          height={`${windowHeight * 0.9}px`}
          overlays={overlays}
          collarStyle={collarStyle}
          projection={projection}
          basemap={basemap}
          collarOpacity={collarOpacity}
        />
      </div>
    </div>
  )
}

export default App
